import { DocumentNode, gql } from '@apollo/client'

export const ACTIVE_MERGER: DocumentNode = gql`
    mutation ActiveMerger($daycareId: Int!) {
        activeMerger(daycare_id: $daycareId)
    }
`

export const DEACTIVE_MERGER: DocumentNode = gql`
    mutation DeactiveMerger($daycareId: Int!) {
        deactiveMerger(daycare_id: $daycareId)
    }
`
